import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%2C%20dreamy%20fantasy%20cityscape%20with%20floating%20islands%2C%20warm%20sunset%20sky%20with%20golden%20clouds%2C%20magical%20particles%2C%20soft%20atmospheric%20lighting%2C%20anime%20aesthetic%2C%20ethereal%20and%20romantic%20mood%2C%20stylized%20artistic%20background&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="奇漫屋 - 免费韩国漫画在线阅读平台"
        title="奇漫屋 - 韩漫在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 tracking-wide">
          探索韩漫的无限世界
        </h1>
        <p className="text-sm md:text-lg text-background-200 max-w-2xl mb-8 leading-relaxed">
          奇漫屋汇集海量免费韩国漫画，支持下拉式在线阅读，每日更新热门连载，随时随地畅享精彩故事
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full cursor-pointer border border-background-50/30 hover:bg-background-50/30 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">1000+</div>
            <div className="text-xs text-background-300 mt-1">漫画资源</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">50万+</div>
            <div className="text-xs text-background-300 mt-1">活跃读者</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日</div>
            <div className="text-xs text-background-300 mt-1">持续更新</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}